export default __webpack_public_path__ + "static/media/CAPA_EM_BRANCO_BANDEJA.9c8bb971.webp";